var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "selected-preset-info" }, [
    _c("div", { staticClass: "preset-details" }, [
      _c("h4", [_vm._v(_vm._s(_vm.preset.label))]),
      _vm._v(" "),
      _vm.preset.caption
        ? _c("p", [_vm._v(_vm._s(_vm.preset.caption))])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "preset-meta d-flex justify-content-between" }, [
        _vm.preset.presets && _vm.preset.presets.length
          ? _c("span", { staticClass: "preset-category" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _setup.getCategoryLabel(_vm.preset.presets[0].category)
                  ) +
                  "\n            "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _setup.isFree
          ? _c(
              "span",
              { staticClass: "api-key-indicator" },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: ["fa-solid", "fa-sparkles"] },
                }),
                _vm._v("\n                Free by Customily\n            "),
              ],
              1
            )
          : _c(
              "span",
              { staticClass: "api-key-indicator" },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: ["fa-solid", "fa-key"] },
                }),
                _vm._v("\n                Requires API Key\n            "),
              ],
              1
            ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }